import React, { useState, useEffect } from "react";
import { Modal, SANS_4, UI_BODY_BOLD, UI_BODY_DF, useScreenWidth, getBreakPoint } from 'oolib';
import { _Locale } from "../components/locale/Locale";

export const useGSLHeaderPopupPlugin = () => {
  const [showPopup, setShowPopup] = useState(false);
  const screenWidth = useScreenWidth();

  useEffect(() => {
    const popupShown = localStorage.getItem('gsl_header_popup_shown');
    const isLargeScreen = screenWidth > getBreakPoint("lg");
    
    if (!popupShown && isLargeScreen) {
      setShowPopup(true);
    }
  }, [screenWidth]);

  const handleClosePopup = () => {
    setShowPopup(false);
    localStorage.setItem('gsl_header_popup_shown', 'true');
  };

  const Component = showPopup && (
    <Modal
      title={_Locale("Update")}
      onClose={handleClosePopup}
      showActionPanel={false}
      showCloseBtn={true}
      desktopWidth="600px"
      fitToContentHeight={true}
    >
      <div style={{ padding: "2rem" }}>
        <UI_BODY_DF>
          You can now change the language of the platform and access your profile settings from the top-right corner of your screen, next to the “Write Here” button. 
        </UI_BODY_DF>
      </div>
    </Modal>
  );

  return {
    Component
  };
}; 